import React from 'react';
import {BrowserRouter, Route, Switch, history, Redirect} from 'react-router-dom';
import {hot} from 'react-hot-loader';
import {Provider} from 'react-redux';
import {LocaleProvider} from 'antd';
import cn from 'antd/lib/locale-provider/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import Store from '../store';
import DevTools from '../store/DevTools';
//登陆
import Login from '../containers/frontEnd/login/login';
//后台主页(入口) jimiyang
import Main from '../containers/backEnd/main/main';
import List from '../containers/backEnd/productManagement/list';
import DeliveryList from '../containers/backEnd/deliveryMangement/deliverylist';
import TypeList from '../containers/backEnd/productType/typelist';
import addGoods from '../containers/backEnd/productManagement/addGoods';
import brandList from '../containers/backEnd/brandMangement/brandlist';//品牌管理列表
import inventoryList from '../containers/backEnd/inventoryMangement/inventorylist';//库存管理列表
import facilityList from '../containers/backEnd/facilityMangement/facilitylist';//设备管理列表
import packageList from '../containers/backEnd/packageMangement/packagelist';//套餐管理
import SelectGoods from '../containers/backEnd/packageMangement/selectgoods';//选择商品
import EditGroupGoods from '../containers/backEnd/packageMangement/editgoods';//编辑套餐商品
import topupList from '../containers/backEnd/topupMangement/topuplist';//充值管理
import Detail from '../containers/backEnd/topupMangement/detail';//充值管理详情
import CheckDetail from '../containers/backEnd/topupMangement/check';//充值管理审核详情
import NotFound from '../containers/404';

//前台
import App from '../containers/frontEnd/app/app';
import goods from '../containers/frontEnd/goods/goods'; // 商品首页
import searchDetail from '../containers/frontEnd/searchDetail/searchDetail'; // 商品查找页面
import goodsDetail from '../containers/frontEnd/goodsDetail/goodsDetail'; // 商品详情
import generateOrder from '../containers/frontEnd/generateOrder/generateOrder'; // 订单信息
import cashier from '../containers/frontEnd/cashier/cashier'; // 支付页
import successfulPayment from '../containers/frontEnd/successfulPayment/successfulPayment'; // 支付成功
import orderList from '../containers/frontEnd/orderList/orderList'; // 订单列表
import orderDetail from '../containers/frontEnd/orderDetail/orderDetail'; // 订单详情
import deviceManagement from '../containers/frontEnd/deviceManagement/deviceManagement'; // 设备管理
import personalDetails from '../containers/frontEnd/personalDetails/personalDetails'; // 个人详情
import rechargeApplication from '../containers/frontEnd/rechargeApplication/rechargeApplication'; // 支付申请
import ActivationList from '../containers/module/activationManagement/activationList';

moment.locale('cn');
const Router = ({component: Component, children, ...rest}) => (
  <Route
    {...rest}
    render={props => (
      <Component {...props} ><Switch>{children}</Switch></Component>
    )}
  />
);
const Root = () => (
  <LocaleProvider locale={cn}>
    <BrowserRouter>
      <Provider store={Store}>
        <Switch>
          <Route exact path="/login" component={Login} />
          <Route exact path="/cms/activationCode" render={props => <ActivationList {...props} moduleType="cms" />} />
          <Route exact path="/ms/activationCode" render={props => <ActivationList {...props} moduleType="ms" />} />
          <Router path="/main" component={Main} >
            <Route exact path="/main/list" component={List} />
            <Route exact path="/main/deliverylist" component={DeliveryList} />
            <Route exact path="/main/typelist" component={TypeList} />
            <Route exact path="/main/addGoods" component={addGoods} />
            <Route exact path="/main/brandlist" component={brandList} />
            <Route exact path="/main/inventorylist" component={inventoryList} />
            <Route exact path="/main/facilitylist" component={facilityList} />
            <Route exact path="/main/packagelist" component={packageList} />
            <Route exact path="/main/selectgoods" component={SelectGoods} />
            <Route exact path="/main/editgoods" component={EditGroupGoods} />
            <Route exact path="/main/topuplist" component={topupList} />
            <Route exact path="/main/detail" component={Detail} />
            <Route exact path="/main/check" component={CheckDetail} />
            <Redirect to="/main/list" />
            <Route path="*" component={NotFound} />
          </Router>
          <Router path="/" component={App} >
            <Route exact path="/goods" component={goods} />
            <Route exact path="/searchDetail" component={searchDetail} />
            <Route exact path="/goodsDetail" component={goodsDetail} />
            <Route exact path="/generateOrder" component={generateOrder} />
            <Route exact path="/cashier" component={cashier} />
            <Route exact path="/successfulPayment" component={successfulPayment} />
            <Route exact path="/orderList" component={orderList} />
            <Route exact path="/orderDetail" component={orderDetail} />
            <Route exact path="/deviceManagement" component={deviceManagement} />
            <Route exact path="/personalDetails" component={personalDetails} />
            <Route exact path="/rechargeApplication" component={rechargeApplication} />

            {/* 根据sourceCMS判断是否跳转到searchDetail {type: 'property', id: 3} 流量产品 */}
            {
              window.localStorage.getItem('sourceCMS') === '1'
                ? <Redirect to={{pathname: '/searchDetail', state: {type: 'property', id: 3}}} />
                : <Redirect to="/goods" />
            }
            <Route path="*" component={NotFound} />
          </Router>
        </Switch>
      </Provider>
    </BrowserRouter>
  </LocaleProvider>
);

export default hot(module)(Root);



// WEBPACK FOOTER //
// ./src/router/index.js